<div id="error" fxLayout="column" fxLayoutAlign="start center">

    <div class="content p-8" fxLayout="column" fxLayoutAlign="center center">
        <div class="logo">
            <img src="assets/images/logos/artstuff.svg">
        </div>

        <div class="error-image">
            <img src="./assets/images/errors/maintenance.svg" />
        </div>

        <div class="error-title mt-24">
            {{errorTitle|translate}}
        </div>

        <div class="error-message mt-8">
            {{errorMessage|translate}}
        </div>

    </div>

</div>

